import primitiveColors from '../common/primitive-colors';

const colors = {
  primary: primitiveColors.PRIMARY,
  secondary: primitiveColors.SECONDARY,
  background: primitiveColors.NEUTRAL_900,
  foreground: primitiveColors.NEUTRAL_700,
  text: primitiveColors.NEUTRAL_100,
  textInverted: primitiveColors.NEUTRAL_900,
  textContrast: primitiveColors.NEUTRAL_800,
  textDescription: primitiveColors.NEUTRAL_400,
  saturated: primitiveColors.NEUTRAL_200,
  semiSaturated: primitiveColors.NEUTRAL_500,
  border: primitiveColors.NEUTRAL_300,
  borderOpacity: primitiveColors.NEUTRAL_600,
  warning: primitiveColors.YELLOW_100,
  success: primitiveColors.GREEN_100,
  error: primitiveColors.RED_100,
};

export default colors;
